// 导游模块
import $http from '../../utils/http';
const oldPath = 'tio/lxsdygl'; // tio服务
const guidePath = 'team-supervision-backend/api/guide_backend'; // 导游的服务
const travelPath = 'team-supervision-backend/api/travel'; // 调旅行社服务

export const guideCityList = params => {
    // 城市列表
    return $http({
        url: guidePath + '/common/cityList',
        params,
        method: 'get'
    });
};

export const guideHomeAllList = params => {
    // 导游首页全部列表
    return $http({
        url: guidePath + '/home/guide/all/list',
        params,
        method: 'get'
    });
};
export const guideHomeDashboard = params => {
    // 导游首页数据
    return $http({
        url: guidePath + '/home/guide/dashboard',
        params,
        method: 'get'
    });
};

export const guideAllTrend = params => {
    // 导游首页近12个月趋势
    return $http({
        url: guidePath + '/home/guide/all/trend',
        params,
        method: 'get'
    });
};
export const guideBlackList = params => {
    // 导游首页黑名单排名
    return $http({
        url: guidePath + '/home/guide/black/list',
        params,
        method: 'get'
    });
};
export const guideBlackTrend = params => {
    // 导游首页黑名近12个月趋势
    return $http({
        url: guidePath + '/home/guide/black/trend',
        params,
        method: 'get'
    });
};

export const guideSuperviseList = params => {
    // 导游首页重点关注名单排名
    return $http({
        url: guidePath + '/home/guide/supervise/list',
        params,
        method: 'get'
    });
};
export const guideSuperviseTrend = params => {
    // 导游首页重点关注近12个月趋势
    return $http({
        url: guidePath + '/home/guide/supervise/trend',
        params,
        method: 'get'
    });
};

export const querySupervisionList = data => {
    // 导游重点关注名单查询
    return $http({
        // url: guidePath + '/evaluation/api/guide/querySupervisionList',
        url: guidePath + '/evaluation/guide/querySupervisionList',
        data,
        method: 'POST'
    });
};
export const getBlacklistMessage = data => {
    // 导游黑名单监管信息
    return $http({
        url: guidePath + '/evaluation/api/getBlacklistMessage',
        data,
        method: 'POST'
    });
};
export const querySupervisionRectify = params => {
    // 查看整改记录
    return $http({
        // url: guidePath + '/evaluation/api/guide/supervision/rectify/',
        url: guidePath + '/guide/supervision/rectify/',
        params,
        method: 'get'
    });
};
export const queryBlackList = data => {
    // 导游黑名单查询
    return $http({
        // url: guidePath + '/evaluation/api/guide/queryBlackList',
        url: guidePath + '/evaluation/guide/queryBlackList',
        data,
        method: 'POST'
    });
};

export const rewardsAndPunishment = data => {
    // 导游奖惩
    return $http({
        url: guidePath + '/evaluation/api/score/rewardsAndPunishment',
        data,
        method: 'POST'
    });
};

export const guidePage = data => {
    // 导游列表
    return $http({
        url: guidePath + '/guide/page',
        data,
        method: 'POST'
    });
};

export const querySupervisionByGuideId = data => {
    // 导游重点关注信息
    return $http({
        url: guidePath + '/evaluation/guide/querySupervisionByGuideId',
        data,
        method: 'POST'
    });
};

export const querySupervisionInfo = data => {
    // 导游重点关注明细
    return $http({
        // url: guidePath + '/evaluation/api/score/listPunish',
        url: guidePath + '/score/listPunish',
        data,
        method: 'POST'
    });
};

export const queryListDisorder = data => {
    // 导游其他不规范行为
    return $http({
        // url: guidePath + '/evaluation/api/score/listDisorder',
        url: guidePath + '/score/listDisorder',
        data,
        method: 'POST'
    });
};

export const lastSixMouthData = params => {
    // 查询导游近 6个月评分折线图
    return $http({
        url: guidePath + '/home/guide/abillty/last6mouthData',
        params,
        method: 'GET'
    });
};

export const rectifyNotice = data => {
    // 上传整改通知书
    return $http({
        // url: guidePath + '/evaluation/api/guide/supervision/rectify/notice',
        url: guidePath + '/guide/supervision/rectify/notice',
        data,
        method: 'POST'
    });
};
export const rectifyMaterial = data => {
    // 上传整改资料
    return $http({
        // url: guidePath + '/evaluation/api/guide/supervision/rectify/material',
        url: guidePath + '/guide/supervision/rectify/material',
        data,
        method: 'POST'
    });
};
export const rectifyPlan = data => {
    // 上传整改方案
    return $http({
        // url: guidePath + '/evaluation/api/guide/supervision/rectify/plan',
        url: guidePath + '/guide/supervision/rectify/plan',
        data,
        method: 'POST'
    });
};
export const getComplaint = data => {
    // 投诉列表
    return $http({
        url: guidePath + '/getComplaint',
        data,
        method: 'POST'
    });
};
export const queryItinerary = data => {
    // 行程单列表
    return $http({
        url: guidePath + '/itineraray/queryItinerary',
        data,
        method: 'POST'
    });
};
export const getUser = data => {
    let path = data.type === 'GUIDE' ? guidePath : travelPath
    // 用户信息
    return $http({
        url: path + '/evaluation/api/common/getUser',
        // data,
        method: 'POST'
    });
};
export const queryHistorySupervision = params => {
    // 历史监管记录
    return $http({
        // url: guidePath + '/evaluation/api/rule/querySupervisionLogByGuideId',
        url: guidePath + '/rule/querySupervisionLogByGuideId',
        params,
        method: 'get'
    });
};
export const Jurisdiction = params => {
    // 首页导游权限 tio接口
    return $http({
        url: oldPath + '/Jurisdiction',
        params,
        method: 'get'
    });
};
export const guideInfo = data => {
    // 导游详情
    return $http({
        url: guidePath + '/guide/findGuideById',
        data,
        method: 'POST'
    });
};

export const guideMark = data => {
    // 导游评分
    return $http({
        url: guidePath + '/evaluation/guide/query',
        data,
        method: 'POST'
    });
};

export const guideDiscuss = data => {
    // 导游评论
    return $http({
        url: guidePath + '/complainEvaluation/remark',
        data,
        method: 'POST'
    });
};

export const guideDiscussDetail = data => {
    // 导游评分详情
    return $http({
        url: guidePath + '/evaluation/api/score/detail',
        data,
        method: 'POST'
    });
};

export const getCosSession = data => {
    // 上传文件cos获取session
    return $http({
        url: guidePath + '/fileUpload/cos/credential',
        data,
        method: 'GET'
    });
};

export const getNotice = data => {
    // 公告
    return $http({
        url: guidePath + '/evaluation/api/guide/noticeTIO',
        data,
        method: 'POST',
        isNotice: true
    });
};

export const addAward = data => {
    // 上传评分材料1
    return $http({
        // url: guidePath + '/evaluation/api/score/addAward',
        url: guidePath + '/score/addAward',
        data,
        method: 'POST'
    });
};

export const addPublicWelfare = data => {
    // 上传评分材料2
    return $http({
        // url: guidePath + '/evaluation/api/score/addPublicWelfare',
        url: guidePath + '/score/addPublicWelfare',
        data,
        method: 'POST'
    });
};

export const addPunish = data => {
    // 上传评分材料3
    return $http({
        // url: guidePath + '/evaluation/api/score/addPunish',
        url: guidePath + '/score/addPunish',
        data,
        method: 'POST'
    });
};

export const addDisorder = data => {
    // 上传评分材料4
    return $http({
        // url: guidePath + '/evaluation/api/score/addDisorder',
        url: guidePath + '/score/addDisorder',
        data,
        method: 'POST'
    });
};
export const addDiscipline = data => {
    // 黑名单全国惩戒
    return $http({
        // url: guidePath + '/evaluation/api/blacklist/guide/addDiscipline',
        url: guidePath + '/blacklist/guide/addDiscipline',
        data,
        method: 'POST'
    });
};
export const cancelDiscipline = data => {
    // 黑名单全国惩戒
    return $http({
        // url: guidePath + '/evaluation/api/blacklist/guide/cancelDiscipline',
        url: guidePath + '/blacklist/guide/cancelDiscipline',
        data,
        method: 'POST'
    });
};
export const getCity = data => {
    // 获取城市列表
    return $http({
        // url: guidePath + '/common/cityList',
        url: travelPath + '/pass/tio/cityList',
        data,
        method: 'POST'
    });
};
export const getTravelDetail = data => {
    // 获取旅行社详情
    return $http({
        // url: travelPath + '/travelAgency/message',
        // url: guidePath + '/guideWeb/findTravelById',
        url: travelPath + '/pass/tio/findTravelById',
        data,
        method: 'POST'
    });
};
export const auditYesGuide = data => {
    // 导游审核通过
    return $http({
        url: guidePath + '/guideWeb/auditYesGuide',
        data,
        method: 'POST'
    });
};
export const auditNoGuide = data => {
    // 导游审核不通过
    return $http({
        url: guidePath + '/guideWeb/auditNoGuide',
        data,
        method: 'POST'
    });
};
export const guideAdd = data => {
    // 导游添加黑名单
    return $http({
        // url: guidePath + '/evaluation/api/blacklist/guide/add',
        url: guidePath + '/blacklist/guide/add',
        data,
        method: 'POST'
    });
};
export const guideCancel = data => {
    // 导游退出黑名单
    return $http({
        // url: guidePath + '/evaluation/api/blacklist/guide/cancel',
        url: guidePath + '/blacklist/guide/cancel',
        data,
        method: 'POST'
    });
};
export const postponeBlacklist = data => {
    // 导游黑名单延期
    return $http({
        // url: guidePath + '/evaluation/api/blacklist/guide/postponeBlacklist',
        url: guidePath + '/blacklist/guide/postponeBlacklist',
        data,
        method: 'POST'
    });
};
export const postponeDiscipline = data => {
    // 导游惩戒延期
    return $http({
        // url: guidePath + '/evaluation/api/blacklist/guide/postponeDiscipline',
        url: guidePath + '/blacklist/guide/postponeDiscipline',
        data,
        method: 'POST'
    });
};
export const regionalChangeList = params => {
    // 导游区域变更
    return $http({
        url: guidePath + '/guideWeb/regionalChangeList',
        params,
        method: 'POST'
    });
};
export const guideAwardList = params => {
    // 导游区域变更
    return $http({
        url: guidePath + '/guideWeb/guideAwardList',
        params,
        method: 'POST'
    });
};
export const guidePunish = params => {
    // 导游区域变更
    return $http({
        url: guidePath + '/guideWeb/guidePunish',
        params,
        method: 'POST'
    });
};

export default {
    getCity,
    getTravelDetail,
    guideAwardList,
    guidePunish,
    guideCityList,
    guideHomeAllList,
    guideHomeDashboard,
    guideBlackList,
    guideBlackTrend,
    guideSuperviseList,
    guideSuperviseTrend,
    guideAllTrend,
    querySupervisionList,
    queryListDisorder,
    queryBlackList,
    rewardsAndPunishment,
    guidePage,
    querySupervisionByGuideId,
    querySupervisionInfo,
    lastSixMouthData,
    querySupervisionRectify,
    getBlacklistMessage,
    rectifyMaterial,
    rectifyNotice,
    rectifyPlan,
    getComplaint,
    queryItinerary,
    getUser,
    queryHistorySupervision,
    Jurisdiction,
    guideInfo,
    guideMark,
    guideDiscuss,
    guideDiscussDetail,
    getCosSession,
    getNotice,
    addAward,
    addPublicWelfare,
    addPunish,
    addDisorder,
    addDiscipline,
    cancelDiscipline,
    auditYesGuide,
    auditNoGuide,
    guideAdd,
    guideCancel,
    postponeBlacklist,
    postponeDiscipline,
    regionalChangeList
};
